<template>
  <AuthLayout img="https://cdn.landly.page/images/pulse/19 Coming soon.svg">
    <div slot="inner">
      <div style="max-width: 400px; margin: auto">
        <v-card-title>
          <v-spacer />
          <span>Login</span>
          <v-spacer />
        </v-card-title>
        <v-form v-on:submit.prevent="login(redirectUrl)">
          <v-text-field
            outlined
            dense
            label="E-mail"
            name="email"
            type="email"
            v-model="email"
          />
          <v-text-field
            outlined
            dense
            label="Password"
            name="password"
            type="password"
            v-model="password"
          />
          <div style="text-align: center" class="mt-3">
            <v-btn
              type="submit"
              color="primary"
              rounded
              :loading="$store.state.auth.loginLoading"
              >Login</v-btn
            >
            <!-- disable google login -->
            <div>
              <div class="mt-2"></div>
              <small>OR</small>
              <div class="mt-2"></div>
              <GoogleLoginButton></GoogleLoginButton>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
import { mapActions } from "vuex";
import GoogleLoginButton from "../components/GoogleLoginButton";
import AuthLayout from "./AuthLayout";

export default {
  components: { GoogleLoginButton, AuthLayout },
  computed: {
    email: {
      get: function () {
        return this.$store.state.auth.login.email;
      },
      set: function (e) {
        this.$store.commit("auth/UPDATE_LOGIN_EMAIL", e);
      },
    },
    password: {
      get: function () {
        return this.$store.state.auth.login.password;
      },
      set: function (e) {
        this.$store.commit("auth/UPDATE_LOGIN_PASSWORD", e);
      },
    },
    redirectUrl() {
      return this.$route.query.redirectUrl;
    },
  },
  methods: {
    ...mapActions({
      login: "auth/login",
    }),
  },
  created() {
    document.title = "Login - Landly Console";
  },
};
</script>